import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { PersonService } from './../../person/models/person.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AddWegoAdminPopupComponent } from './add-wegoadmin-popup.component';
import { WegoAdminModel } from '../models/wegoadmin.model';
import { WegoAdminService } from '../models/wegoadmin.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  UserRoles,
  DataListModel
} from '../../shared/config';

@Component({
  selector: 'wego-wegoadminlist-list',
  template: require('../views/wegoadmin-list.component.html'),
  providers: [WegoAdminService, PersonService]
})
export class WegoAdminListComponent implements OnInit {
  DataListModel: DataListModel;
  WegoAdminList: WegoAdminModel[];
  errorMessage: string;
  isLoading: boolean;
  urlVehicleAttributeUpdate: string;
  urlDefaultPage: string;
  message: string;
  isParentCheck: boolean;
  deleteMessage: string;
  urlPersonUpdate: string;
  wegoAdminHashId: string;
  inActiveMessage: string;
  activeFlag: boolean;
  wegoadminUser: string;
  public adminDependencyvalidationMessage: string;
  adminDependencyModelTitle: string;
  expirationDays: string = "";

  private popupMsg: string;
  private popupTitle: string;
  private module: string;
  private breadCrumbList: string;
  lblBlock: string;
  lblUnblock: string;
  private resetPersonHashId: string;

  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('wegoAdminModal') public wegoAdminModal: any;
  @ViewChild('alertModal') public alertModal: any;
  @ViewChild('inActiveModal') public inActiveModal: any;
  @ViewChild('resetPasswordModal') public resetPasswordModal: any;
  @ViewChild('adminDependencyModal') public adminDependencyModal: any;

  get isAnyChecked(): boolean {
    if (this.WegoAdminList) {
      let isCheck = this.WegoAdminList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.WegoAdminList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else this.isParentCheck = false;
      } else {
        this.isParentCheck = false;
      }
      return isCheck;
    } else {
      this.isParentCheck = false;
      return false;
    }
  }

  constructor(
    private wegoadminService: WegoAdminService,
    private authService: AuthService,
    private personService: PersonService,
    private router: Router,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.wegoadminUser = WeGoConfig.WEGOADMIN_USER;
    this.lblBlock = this.translate.instant('LblBlock');
    this.lblUnblock = this.translate.instant('LblUnblock');
    this.module = this.translate.instant('LblWegoAdmin');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = [
      'userName',
      'instanceName',
      'firstName',
      'lastName',
      'telephone1'
    ];
    this.adminDependencyModelTitle = this.translate.instant(
      'LblAdminDependencyAlert'
    );
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlPersonUpdate = this.authService.GetURL(
      ApplicationRouteURL.URL_PERSON_UPDATE
    );
    this.GetWegoAdminist();
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);

    this.GetTwoFAValidityDays();
  }

  public SuccessAdminDependencyModalClick() {
    this.adminDependencyModal.hide();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetWegoAdminist();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    this.GetWegoAdminist();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetWegoAdminist();
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetWegoAdminist();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.wegoadminService.ExportWegoAdminList(this.DataListModel).subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = 'WegoAdmin' + new Date().toISOString() + '.csv';
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public OnParentCheck(isChecked: boolean) {
    this.WegoAdminList.forEach(x => (x.isChecked = isChecked));
  }

  public DeleteWegoAdmin(deletewegoAdminList: string[]) {
    this.isLoading = true;
    this.wegoadminService.DeleteWegoAdmin(deletewegoAdminList).subscribe(
      res => {
        if (!res.data) {
          this.adminDependencyvalidationMessage = this.translate.instant(
            'LblWegoAdminDependencyValidation'
          );
          this.adminDependencyModal.show();
          this.isLoading = false;
        } else {
          this.DataListModel.currentPage = 1;
          this.GetWegoAdminist();
          this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [
            this.module
          ]);
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public GetWegoAdminist() {
    this.isLoading = true;
    this.wegoadminService.GetWegoAdminList(this.DataListModel).subscribe(
      res => {
        this.WegoAdminList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public InActiveWegoAdmin() {
    this.isLoading = true;
    this.wegoadminService.InActiveWegoAdmin(this.wegoAdminHashId).subscribe(
      res => {
        if (res.data) {
          this.inActiveModal.hide();
          this.DataListModel.currentPage = 1;
          this.GetWegoAdminist();
          this.popupMsg = this.translate.instant(
            'LblRecordBlokUnBlockSuccess',
            [this.module, this.inActiveMessage]
          );
          this.ShowSuccessPopup();
        } else {
          this.isLoading = false;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }
  //Reset wego admin password
  public ResetPersonPassword(personHashID: string) {
    this.personService.ResetPersonPassword(personHashID).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblResetPasswordSuccess');
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant('LblResetPasswordFailure');
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ShowResetPasswordModal(personHashID: string): void {
    this.resetPersonHashId = personHashID;
    this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
    this.resetPasswordModal.show();
  }

  public ResendActivationMail(personHashID: string): void {
    this.resetPersonHashId = personHashID;
    this.personService.ReSendActivationMail(personHashID).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant(
            'LblResendActivationMailSuccess'
          );
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant(
            'LblResendActivationMailFailure'
          );
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public HideResetPasswordModal(): void {
    this.resetPersonHashId = '';
    this.resetPasswordModal.hide();
  }

  public SuccessResetPasswordModalClick(): void {
    this.resetPasswordModal.hide();
    this.ResetPersonPassword(this.resetPersonHashId);
  }

  public ShowAlertModal(): void {
    this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [
      this.module
    ]);
    this.alertModal.show();
  }

  public HideAlertModal(): void {
    this.alertModal.hide();
  }

  public SuccessAlertModalClick(): void {
    let deletewegoAdminList: any[];
    deletewegoAdminList = this.WegoAdminList.filter(x => x.isChecked).map(
      x => x.wegoAdminHashId
    );
    this.DeleteWegoAdmin(deletewegoAdminList);
    this.alertModal.hide();
  }
  public ShowWegoAdminModal() {
    this.wegoAdminModal.show();
  }

  public SuccessWegoAdminModal($event: any) {
    this.GetWegoAdminist();
    this.popupMsg = $event.SuccessMessage;
    this.ShowSuccessPopup();
  }

  public ShowInActiveModal(wegoAdminHashId: string, isActive: boolean): void {
    this.wegoAdminHashId = wegoAdminHashId;
    this.activeFlag = isActive;
    this.inActiveMessage = isActive
      ? this.translate.instant('LblBlock')
      : this.translate.instant('LblUnblock');
    this.popupMsg = this.translate.instant('LblBlockUnblockConfirm', [
      this.inActiveMessage,
      this.module
    ]);
    this.inActiveModal.show(this.popupMsg);
  }

  public ResetCookies() {
    this.wegoadminService.ResetTwoFaCookies()
      .subscribe(
        (res: any) => {
          if (res.data) {
            this.popupTitle = this.translate.instant('LblSuccess');
            this.popupMsg = this.translate.instant('LblCookieResetSuccess', [this.module]);
            this.ShowSuccessPopup();
          }
          else {
            this.popupTitle = this.translate.instant('LblError');
            this.popupMsg = this.translate.instant('LblCookieResetFailed');
            this.ShowSuccessPopup();
          }
        },
        (error: any) => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);

        });
  }

  public ResetTwoFA() {
    this.wegoadminService.ResetTwoFaKeys()
      .subscribe(
        (res: any) => {
          if (res.data) {
            this.popupTitle = this.translate.instant('LblSuccess');
            this.popupMsg = this.translate.instant('LblKeyResetSuccess', [this.module]);
            this.ShowSuccessPopup();
          }
          else {
            this.popupTitle = this.translate.instant('LblError');
            this.popupMsg = this.translate.instant('LblKeyResetFailed');
            this.ShowSuccessPopup();
          }
        },
        (error: any) => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        });
  }

  public SaveTwoFA() {
    this.wegoadminService.UpdateTwoFAValidityDays(this.expirationDays)
      .subscribe(
        (res: any) => {
          if (res.data) {
            this.popupTitle = this.translate.instant('LblSuccess');
            this.popupMsg = this.translate.instant('LblRecordSavedSuccess', [this.module]);
            this.ShowSuccessPopup();
          }
          else {
            this.popupTitle = this.translate.instant('LblError');
            this.popupMsg = res.error;
            this.ShowSuccessPopup();
          }
        },
        (error: any) => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);

        });
  }

  public GetTwoFAValidityDays() {
    this.isLoading = true;
    this.wegoadminService.GetTwoFAValidityDays().subscribe(
      res => {
        this.expirationDays = res.data;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ResetPersonCookies(personHashId: string) {
    this.resetPersonHashId = personHashId;
    this.personService.ResetTwoFaCookie(personHashId).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant(
            'LblCookieResetSuccess'
          );
          this.ShowSuccessPopup();
        } else {
          this.popupTitle = this.translate.instant('LblError');
          this.popupMsg = this.translate.instant(
            'LblCookieResetFailed'
          );
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ResetPersonTwoFA(personHashId: string) {
    this.resetPersonHashId = personHashId;
    this.personService.ResetTwoFaKey(personHashId).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant(
            'LblKeyResetSuccess'
          );
          this.ShowSuccessPopup();
        } else {          
          this.popupMsg = this.translate.instant(
            'LblKeyResetFailed'
          );
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public HideInActiveModal(): void {
    this.wegoAdminHashId = '';
    this.inActiveModal.hide();
  }

  public SuccessInActiveModalClick(): void {
    this.InActiveWegoAdmin();
    this.inActiveModal.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/wegoadminlist/components/wegoadmin-list.component.ts